module.exports =
{

  _init: function ()
  {

    this.onSave()

    this.onPay()

  },

  onSave: function ()
  {

    $('#modal-save').not('.js-ignore').click(function ()
    {

      $('#modal-continue').val(1)

      $('#modal-submit').trigger('click')

    }).addClass('js-ignore')

  },

  onPay: function ()
  {

    $('#modal-pay').not('.js-ignore').click(function ()
    {

      $('#modal-continue').val(2)

      $('#modal-submit').trigger('click')

    }).addClass('js-ignore')

  }

}